import { formatContentSelectValue } from '../utils'
import api from './connectionProxy'

export const getPreRegistrations = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params

  return api.http.get('/pre_registrations/', {
    params: {
      page,
      per_page: perPage,
      column: (order || {}).column || '',
      direction: (order || {}).direction || 1,
      term
    }
  })
}

export const addPreRegistration = data => {
  return api.http.post('/pre_registrations', data)
}

export const getPreRegistration = id => {
  return api.http.get(`/pre_registrations/${id}`)
}

export const getBookPreRegistrationByIsbn = isbn => {
  return api.http.get(`/pre_registrations/book/by-isbn/${encodeURIComponent(isbn)}`)
}

export const editPreRegistration = (data, _id) => {
  return api.http.put(`/pre_registrations/${_id}`, data)
}

export const deletePreRegistration = id => {
  return api.http.delete(`/pre_registrations/${id}`)
}

export const restorePreRegistration = id => {
  return api.http.put(`/pre_registrations/${id}/restore`)
}

export const searchPreRegistrations = ({ term, type }) => {
  return api.http.get('/pre_registrations/select_search', {
    params: {
      term,
      type
    }
  })
}

export const getSelectPreRegistrations = type => (term, callback) => {
  searchPreRegistrations({ type, term }).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)

    callback(null, {
      options,
      complete: true
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/preRegistrations.js